// extracted by mini-css-extract-plugin
module.exports = {"description":"FiscalCalendar_description__h2AW1","item":"FiscalCalendar_item__RGtzB"};